import * as actions from "../action.constants";

export const requestAdvancedProbeTypes = () => ({
  type: actions.REQUEST_ADVANCED_PROBE_TYPES,
});

export const storeAdvancedProbeTypes = (data) => ({
  type: actions.STORE_ADVANCED_PROBE_TYPES,
  payload: data,
});

export const requestSlaveList = (probeId) => ({
  type: actions.REQUEST_SLAVE_LIST,
  probeId,
});

export const storeSlaveList = (data) => ({
  type: actions.STORE_SLAVE_LIST,
  payload: data,
});

export const updateSlave = (probeId, data, callback) => ({
  type: actions.UPDATE_SLAVE,
  probeId,
  payload: data,
  callback,
});
